export const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;
export const MAPBOX_API = "https://api.mapbox.com/geocoding/v5/mapbox.places/";
export const MAPBOX_REVERSE_GEOCODING_API = "https://api.mapbox.com/search/geocode/v6/reverse?";
export const MAPBOX_SEARCH_BOX_API = "https://api.mapbox.com/search/geocode/v6/forward?";
export const distanceUnit = "meters";
export const country = "France";
export const countrySymbol = "fr";
